import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ConsulenzaItStrategica from "./sections/ConsulenzaItStrategica";
import EcosistemiOperativi from "./sections/EcosistemiOperativi";
import IlDnaDellaConsulenza from "./sections/IlDnaDellaConsulenza";
import CoreExpertise from "./sections/CoreExpertise";
import FeedbackERisultati from "./sections/FeedbackERisultati";
import IniziamoLaTrasformazione from "./sections/IniziamoLaTrasformazione";
import PièDiPagina from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ConsulenzaItStrategica />
      <EcosistemiOperativi />
      <IlDnaDellaConsulenza />
      <CoreExpertise />
      <FeedbackERisultati />
      <IniziamoLaTrasformazione />
      <PièDiPagina />
    </div>;
}